import React from 'react';
import { ReactGlider } from '../ReactGlider';
import Box from '@mui/material/Box';
import { GradientTypography } from '../gradients/GradientTypography';
import { useMobile } from 'src/hooks/useMobile';
import { TeamMemberCard, TeamMemberCardProps } from './TeamMemberCard';

export type TeamCarouselProps = {
  team: TeamMemberCardProps[];
};

export function TeamCarousel({ team }: TeamCarouselProps) {
  const isMobile = useMobile();

  return (
    <Box
      sx={
        isMobile
          ? {
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }
          : {}
      }
    >
      {!isMobile && (
        <GradientTypography
          gradientColor="primary.vertical"
          variant="h5"
          sx={{
            ml: '8px',
            my: 1,
          }}
        >
          THE TEAM
        </GradientTypography>
      )}

      <ReactGlider
        itemWidth={376}
        hasArrows={!isMobile}
        navGradientColor={'primary.verticalInverse'}
        formatContainer={true}
        trackStyle={{ maxWidth: `${team.length * 400}px !important` }}
      >
        {team.map((props) => {
          return (
            <Box sx={{ p: 2 }} key={`slide-${props.name}${props.description}`}>
              <TeamMemberCard {...props} eagerLoad={true} />
            </Box>
          );
        })}
      </ReactGlider>
    </Box>
  );
}
